export const CloudService = [{
    label: "Amazon Web services(AWS)",
    value: "aws",
    serviceType: [
        {
            label: "Create New Account",
            value: "awsNewAWSAccount"
        }, {
            label: "IAM Role ",
            value: "awsIAMRole"
        },
        {
            label: "Application Budget Adjustment",
            value: "applicationBudget"

        },
        {
            label: "Account Budget Adjustment",
            value: "accountBudget"

        },
        {
            label: "IAM User Key and Secret",
            value: "awsiamuserkeysecret"

        },
        {
            label: "Terraform Module",
            value: "terraformModule"

        },
        {
            label: "Other Services",
            value: "aws_Other"

        }]
},
{
    label: "Microsoft Azure",
    value: 'azure',
    serviceType: [
        {
            label: "New Subscription ",
            value: "azureNewSubscription"
        },
        {
            label: "Remove Lock from Resource Group",
            value: "azure_RemoveLock"
        }, {
            label: " Request Policy Exception",
            value: "azure_PolicyException"
        },
        {
            label: "Fix Key Renewal Issue",
            value: "azure_KeyRenewalIsuue"
        },
        {
            label: "Other Azure Services",
            value: "azure_OtherNotListed"
        }
    ]

}, {
    label: "Oracle Cloud Infrastructure (OCI)",
    value: "oci",
    serviceType: [{
        label: "Create Compartment Request",
        value: "createCompartment"

    },
    {
        label: "Decommission Compartment Request",
        value: "decommissionCompartmentRequest"

    },
    {
        label: "Onboard Compartment to Cloud Governance Platform",
        value: "onboardCompartment"

    },
    {
        label: "Create Service Account",
        value: "createServiceAccount"

    },
    {
        label: "Create IAM User Access",
        value: "createIAMUserAccess"

    },
    {
        label: "Modify IAM User Access",
        value: "modifyIAMUserAccess"
    },
    {
        label: "Create IAM Policy",
        value: "createIAMPolicy"
    },

    {
        label: "Modify IAM Policy",
        value: "modifyIAMPolicy"

    },
    {
        label: "Create IAM Group",
        value: "createIAMGroup"

    },
    {
        label: "Modify IAM Group",
        value: "modifyIAMGroup"

    },

    {
        label: "Generate Cost Optimization and Savings Recommendations Report",
        value: "ociCostOptimization"

    },
    {
        label: "Generate Cost Analysis Report by Service and Compartment",
        value: "ociCostAnalysisReport"

    },
    {
        label: "other",
        value: "otherissue"

    }
    ],
}, {
    label: "Cloud Financial Operations (FinOps)",
    value: "finOps"

}]

